<div class="position-relative">
  <div class="document-upload-item" *ngFor="let document of attachedDocuments; let index = index; trackBy: trackByFn">
    <document-upload-desktop
      [id]="'lcl-documents-' + shipmentId + '-' + index + (document.id ? '-' + document.id : '')"
      [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
      [attachmentTypeName]="'MENU.LCL' | translate | uppercase"
      [footerHint]="'LABELS.BROWSE'"
      [isSm]="true"
      [isStretched]="true"
      [isStripeLayout]="true"
      [uploadedDocument]="document"
      [canUploadDocuments]="!document.uploadedDate"
      [canRemoveDocuments]="true"
      (upload)="uploadDocumentCall(document, $event)"
      (remove)="removeDocument(document.id)"
      (stateUpdate)="onDocumentStateUpdate(document.id, $event)"
    ></document-upload-desktop>
  </div>

  <input class="d-none" type="file" #input [accept]="ALLOWED_FILE_MIMES.join(',')" (change)="handleFiles($event)" />

  <div class="add-other-doc" (click)="onAddOtherDocument(enumDocumentType.FREIGHT_OTHER)">
    <span class="add-other-doc-icon"><i class="fa fa-plus"></i></span>
    <span>{{ "BUTTON.ADD_OTHER_DOCUMENT" | translate }}</span>
  </div>

  <div class="add-other-doc mt-2 mb-2" (click)="onAddOtherDocument(enumDocumentType.FREIGHT_FREIGHT_DAMAGED_GOODS_PICS)">
    <span class="add-other-doc-icon"><i class="fa fa-plus"></i></span>
    <span>{{ "BUTTON.ADD_DAMAGED_GOODS_PICS" | translate }}</span>
  </div>

  <div class="add-other-doc" (click)="onAddOtherDocument(enumDocumentType.FREIGHT_FREIGHT_REPACKED_GOODS_PICS)">
    <span class="add-other-doc-icon"><i class="fa fa-plus"></i></span>
    <span>{{ "BUTTON.ADD_REPACKED_GOODS_PICS" | translate }}</span>
  </div>

  <div class="w-100 text-center mt-5">
    <button type="button" class="btn btn-primary" (click)="dataSaved.emit()">{{ "BUTTON.SAVE" | translate }}</button>
  </div>

  <custom-modal [header]="'INCORRECT_INFORMATION.TITLE'" [(open)]="isShowErrorModalOpened">
    <app-control-errors [control]="fileControl" [errors]="errors"></app-control-errors>

    <button footer-action class="btn btn-primary" type="button" (click)="isShowErrorModalOpened = false">
      {{ "BUTTON.CLOSE" | translate }}
    </button>
  </custom-modal>

  <loading-spinner [show]="isLoading"></loading-spinner>
</div>
